import React from 'react';

import { ApIcon, colors } from '@alixpartners/ui-components';
import {
	Tile,
	TileText,
	TileTitle,
	IconWrapper,
} from './ConfigureTypes.styles';
import {
	BASELINE_UPLOAD_TYPES,
	SAVINGS_SIGNOFF_TYPES,
	UPLOAD_TYPES,
} from '../utils';
import { exportSpendOwners } from 'utils/apiRequests';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
// import { extractSelectedArrays } from 'SpendController/utils';
// import { PERMISSIONS } from 'contexts/PermissionsContext';

const CONFIGURE_VISIBLE = [
	'spend-controller/baseline',
	// 'spend-controller/workshop',
	'/spend-controller/saving-sign-off',
];
const EMAIL_VISIBLE = [
	'/spend-controller/preworkshop-template',
	'spend-controller/workshop',
	'/spend-controller/saving-sign-off',
	'/spend-controller/micro-tail-launch',
];
export const UploadTypes = ({ onChange, permissions }) => {
	const location = useLocation();

	return (
		<React.Fragment>
			{CONFIGURE_VISIBLE.some(element =>
				location.pathname.includes(element)
			) && (
				<>
					<Tile
						onClick={async () => {
							onChange(UPLOAD_TYPES.DOWNLOAD);
							if (location.pathname === '/spend-controller/baseline') {
								await exportSpendOwners(1);
							} else if (
								location.pathname === '/spend-controller/saving-sign-off'
							) {
								await exportSpendOwners(7);
							}
						}}
					>
						<IconWrapper>
							<ApIcon
								iconName="download"
								iconColor={colors.grey3}
								iconSize={56}
							/>
						</IconWrapper>
						<TileTitle>Download Spend Owners</TileTitle>
						<TileText>
							System will get all Spend Owners in the Existing Data.
						</TileText>
					</Tile>
					<Tile
						onClick={() => {
							if (location.pathname === '/spend-controller/baseline') {
								onChange(
									UPLOAD_TYPES.UPLOAD,
									BASELINE_UPLOAD_TYPES.UPLOAD_SPEND_OWNER,
									null
								);
							} else if (
								location.pathname === '/spend-controller/saving-sign-off'
							) {
								onChange(
									UPLOAD_TYPES.UPLOAD,
									null,
									SAVINGS_SIGNOFF_TYPES.UPLOAD_SPEND_OWNER
								);
							}
						}}
					>
						<IconWrapper>
							<ApIcon
								iconName="append_outlined"
								iconColor={colors.grey3}
								iconSize={56}
							/>
						</IconWrapper>
						<TileTitle>Upload Spend Owners</TileTitle>
						<TileText>
							System will update Mails for all the Spend Owners .
							<br />
							<span className="red">
								Please make sure that the Spend Owners names are not Modified.
							</span>
						</TileText>
					</Tile>
				</>
			)}
			<>
				{EMAIL_VISIBLE.some(element => location.pathname.includes(element)) && (
					<>
						<Tile
							onClick={async () => {
								onChange(UPLOAD_TYPES.TESTMAIL);
								// await sendMailtoSpendOwners({
								// 	linkNumber: 1,
								// });
							}}
						>
							<IconWrapper>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									height="56px"
									viewBox="0 -960 960 960"
									width="56px"
									fill="#CCCCCC"
								>
									<path d="M480-462 140-685v465h390v60H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v310h-60v-255L480-462Zm0-60 340-218H140l340 218ZM774-44l-42-42 73-74H590v-60h215l-74-74 43-42 146 146L774-44ZM140-685v499-244 4-314 55Z" />
								</svg>
							</IconWrapper>
							<TileTitle>Test Email</TileTitle>
							<TileText>
								System will send test mail to Spend Owner whose email is
								entered.
								<br />
								{/* <span className="red">
						Current data will be lost and can not be restored in the future.
					</span> */}
							</TileText>
						</Tile>
						<Tile
							onClick={async () => {
								onChange(UPLOAD_TYPES.SENDMAIL);
								// await sendMailtoSpendOwners({
								// 	linkNumber: 1,
								// });
							}}
						>
							<IconWrapper>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									height="56px"
									viewBox="0 -960 960 960"
									width="56px"
									fill="#CCCCCC"
								>
									<path d="M480-462 140-685v465h390v60H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v310h-60v-255L480-462Zm0-60 340-218H140l340 218ZM774-44l-42-42 73-74H590v-60h215l-74-74 43-42 146 146L774-44ZM140-685v499-244 4-314 55Z" />
								</svg>
							</IconWrapper>
							<TileTitle>Send Mail</TileTitle>
							<TileText>
								System will send mail to all Spend Owners whose emails are
								entered.
								<br />
								{/* <span className="red">
						Current data will be lost and can not be restored in the future.
					</span> */}
							</TileText>
						</Tile>
					</>
				)}
				{/* {(location.pathname !== '/spend-controller/preworkshop-template' ||
					hasPermission(PERMISSIONS.BaselineRead)) && (
					<>
						<Tile
							onClick={async () => {
								onChange(UPLOAD_TYPES.DOWNLOAD);
								const tempFilters = extractSelectedArrays(filters);
								tempFilters.tailSpendType = spendType;
								await exportSpendController({
									filters: tempFilters,
									type: handleReturnType(),
								});
							}}
						>
							<IconWrapper>
								<ApIcon
									iconName="download"
									iconColor={colors.grey3}
									iconSize={56}
								/>
							</IconWrapper>
							<TileTitle>Download Current Module</TileTitle>
							<TileText>
								System will get all data for the current module and filters.
							</TileText>
						</Tile>
						<Tile
							onClick={async () => {
								onChange(
									UPLOAD_TYPES.UPLOAD,
									BASELINE_UPLOAD_TYPES.UPLOAD_CURRENT_MODULE
								);
							}}
						>
							<IconWrapper>
								<ApIcon
									iconName="append_outlined"
									iconColor={colors.grey3}
									iconSize={56}
								/>
							</IconWrapper>
							<TileTitle>Upload Current Module</TileTitle>
							<TileText>
								System will get all Data for the current module for the applied
								filters.
							</TileText>
						</Tile>
					</>
				)} */}
			</>
		</React.Fragment>
	);
};
